import BasePage from './BasePage';
import { connect } from 'react-redux';
import configData from "../config.json";
import {setMenu,setModalContent, setUsers} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Table from '../components/Table';
import Seeker from '../components/Seeker';
import $ from 'jquery';

class Users extends BasePage {

    loadOnConstructor(){
    	this.getUsers = this.getUsers.bind(this);
    	this.newUser = this.newUser.bind(this);
    	this.deleteClick= this.deleteClick.bind(this);
    	this.deleteUser = this.deleteUser.bind(this);
    	this.deleteUserCallback = this.deleteUserCallback.bind(this);
    	this.clickPaginationCallback = this.clickPaginationCallback.bind(this);
   	this.searchCallback = this.searchCallback.bind(this);
   	this.changeSeekerContent = this.changeSeekerContent.bind(this);
   	this.handleSeekerChange = this.handleSeekerChange.bind(this);

    	this.state = {};

    	this.getUsers();
    }

    handleSeekerChange(event, previousSearchValue){

	    const api = this.getApi();
	    let params = [];

            ['name_like','lastname_like','email_like'].map(p => {
		    return params.push({name: p, value: event.target.value});
	    });
	    params.push({name: 'conditions_type', value: 'or'});
	    this.changeSeekerContent(params);

            const aditionalParams = [
		{name: 'page', value:this.state.page?this.state.page:1}, 
    		{name: 'limit', value: configData.rowsPerPage}
            ];

	    params = params.concat(aditionalParams);
	    if(previousSearchValue !== event.target.value){
	    	params = params.map(elem => {
	    		if(elem.name === 'page') elem.value = 1;
			return elem;
		});
	    }

	    api.getUsers(params,this.searchCallback);
    }

    searchCallback(response){
	 this.props.setUsers(response.users);
	 this.setState(prevState => {
		 return {
			...prevState,
			totalItems: response.totalItems,
			totalPages: response.totalPages,
			currentPage: response.currentPage,
			canCreateUsers: response.canCreateUsers
		 }
	 });

    }

    getUsers(){
    	const api = this.getApi();
    	let apiParams = [
    		{name: 'page', value:this.state.page?this.state.page:1}, 
    		{name: 'limit', value: configData.rowsPerPage}
    	];

    	if(this.state.searchParams){
		apiParams = apiParams.concat(this.state.searchParams);
	}

	api.getUsersForMe(apiParams, (response) => {
		if(response.status === 'OK'){
			this.props.setUsers(response.users);
			this.setState(prevState => {
				return {
					...prevState,
					totalItems: response.totalItems,
					totalPages: response.totalPages,
					currentPage: response.currentPage,
					canCreateUsers: response.canCreateUsers,
					i18n: response.i18n
				}
			});
		}else if(response.auth === false){
			this.navigateTo('/login');
		}
	});
    }

    newUser(){
	this.navigateTo('/edit_user');
    }

    clickPaginationCallback(pageNumber){
	this.setState(prevState => {
		return {
			...prevState,
			page: pageNumber
		}
	}, this.getUsers);
    }

    deleteClick(event){

	this.props.setModalContent({
		title: this.getTrad('confirmAction'),
		body: [this.getTrad('confirmDeleteUser')],
		buttons: [
			{shown: 'Aceptar', close: true,  behaviour: 'main', callback: this.deleteUser.bind(this,event.target.id)},
			{shown: 'Cancelar', behaviour: 'secondary', close: true}
		]
	});

	$("#exampleModal").modal('toggle');
    }

    deleteUser(buttonName){
    	const parts = buttonName.split('_');

	this.setState(prevState => {
		return {
			...prevState,
			deletedUser: parts[1]
	}});
	const api = this.getApi();
	api.deleteUser(parts[1],this.deleteUserCallback);
    }

    deleteUserCallback(response){
	
	if(response && response.status === 'OK'){
		this.props.setUsers(this.props.users.filter(user => { return user._id !== this.state.deletedUser }));
		setTimeout(() => {
		this.props.setModalContent({
			title: this.getTradd('messageFromServer'),
			body: [this.getTrad('userWasDeletedSuccessfully')],
			buttons: [
				{shown: 'Cerrar', close: true,  behaviour: 'main'}
			]
		});

		$("#exampleModal").modal('toggle');
		}, 500);
	}else{
		setTimeout(() => {
		this.props.setModalContent({
			title: this.getTradd('messageFromServer'),
			body: [this.getTrad(response.message)],
			buttons: [
				{shown: 'Cerrar', close: true,  behaviour: 'main'}
			]
		});

		$("#exampleModal").modal('toggle');
		}, 500);
	}
    }

    changeSeekerContent(newSearchParams){
	 this.setState(prevState => {
		 return {
			 ...prevState,
			 searchParams: newSearchParams
		 }
	 });
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.getTrad('usersAdministration')}</h3>
                <div className="row mb-2 mt-4">
                    <div className="col-6">
			{this.state.canCreateUsers?<button type="button" className="btn btn-primary" onClick={this.newUser}>
			  Nuevo usuario
			</button>:''}
                    </div>
                    <div className="col-6 text-right">
                    	<Seeker 
                    		config={ {
                    			shown:'name', 
                    			setHandler: this.searchCallback,
                    			items: this.props.users,
                    			handleChangeCallback: this.handleSeekerChange
                    		} }
                    	/>
                    </div>
                </div>
                <div className="row">
			<div className="col-12">
				<Table 
					config = {{
						items: this.props.users,
						i18n: this.state.i18n !== undefined?this.state.i18n:[], 
						mapping: [
							{original: 'id', shown: 'ID', visible: true, click:{
								url: '/edit_user', params: [{name: 'user_id', field: '_id' }] }},
							{original: 'name', shown: 'Nombre', visible: true, click:{
								url: '/edit_user', params: [{name: 'user_id', field: '_id' }] }},
							{original: 'lastname', shown: 'Apellidos', visible: true, click:{
								url: '/edit_user', params: [{name: 'user_id', field: '_id' }] }},
							{original: 'email', shown: 'Email', visible: true, click:{
								url: '/edit_user', params: [{name: 'user_id', field: '_id' }] }},
							{original: 'profile_name', shown: 'Perfil', visible: true, click:{
								url: '/edit_user', params: [{name: 'user_id', field: '_id' }] }},
							{original: '_id', shown: '_id', visible: false},
							{original: '_id', button:'X', shown: 'Eliminar', visible: true, display:'button',
								prefix: 'deleteuser_', click_callback: this.deleteClick}
						],
						pagination:{
							totalItems: this.state.totalItems?this.state.totalItems:0,
							totalPages: this.state.totalPages?this.state.totalPages:1,
							currentPage: this.state.currentPage?this.state.currentPage:1,
							callback: this.clickPaginationCallback

						}
					}}
				/>
			</div>
                </div>

		<Modal />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        users: state.users
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setMenu(menu){
            dispatch(setMenu(menu));
        },
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	},
        setUsers(users){
            dispatch(setUsers(users));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users)
